const renderSettingsImage = () => {
    return <div />;
};
export default renderSettingsImage;
